(function($){

    document.documentElement.classList.add('fade-out');
    document.documentElement.classList.add('loading');

    $(window).on("load", function () {
        setTimeout(function() {
            document.documentElement.classList.remove('fade-out');
            document.documentElement.classList.remove('loading');
        }, 80);
    });


    $('a').click(function(e) {
        href = $(this).attr('href');
        target = $(this).attr('target');


        //build exclusions list
        if ( $(this).is('.is-lightbox a') ) return;
        if ( $(e.target).hasClass('item-toggle')  ) return;
        

        if ( $(e.href).startsWith('#') == false ) {
            const isExternalURL = new URL(href, location.origin).origin !== location.origin;
            e.preventDefault();
            document.documentElement.classList.add('fade-out');
            setTimeout(function() {
                if ( target == '_blank' || isExternalURL ) {
                    window.open( href, "_blank");
                    document.documentElement.classList.remove("fade-out");
                    document.documentElement.classList.remove("loading");
                } else {
                    window.location = href;
                }
            }, 50);
        }
    });

})(jQuery);